import { Route, Routes, useLocation } from "react-router-dom";
import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import Index from "./pages";
import AboutUs from "./pages/aboutus";
import Blog from "./pages/blogs";
import BlogDetails from "./pages/blog-detail";
import EventDetail from "./pages/event-detail";
import ContactUs from "./pages/contacto";
import Pay from "./pages/sidom-pay";
import Isurance from "./pages/sidom-insurance";
import Misim from "./pages/sidom-misim";
import SmartReader from "./pages/sidom-smart-reader";
import Eventos from "./pages/sidom-eventos";
import AccesoAcliente from "./pages/sidom-acceso-cliente";
import Mre from "./pages/sidom-mre";
import PrivacyPolicy from "./components/PrivacyPolicy";
import Login from "./pages/Login";
// import Dashboard from "./pages/Dashboard";
// import PrivateRoute from "./components/PrivateRoute";
import MetaPixel from "./components/MetaPixel";
// import GoogleAnalytics from "./components/GoogleAnalytics";
import GoogleAds from "./components/GoogleAds";
import Landing from "./pages/info";
import { useConsentStore } from "./store/useConsentStore";
import FaqLanding from "./pages/faq-landing";
import FaqDetail from "./pages/faq-detail";

import NotFound from "./pages/NotFound";

function App() {
  const location = useLocation();
  const setConsent = useConsentStore((s) => s.setConsent);
  useEffect(() => {
    const saved = localStorage.getItem("cookieConsent");
    if (saved) {
      try {
        setConsent(JSON.parse(saved));
      } catch (e) {}
    }
  }, [setConsent]);
  useEffect(() => {
    AOS.init({ duration: 500, once: false, offset: 0 });
  }, []);
  useEffect(() => {
    AOS.refresh();
  }, [location]);
  return (
    <div className="App">
      {/** Tracking --> */}
      <MetaPixel />
      {/* <GoogleAnalytics /> */}
      <GoogleAds />
      {/** Tracking */}
      <Routes>
        <Route path="/" element={<Index />} />
        {/** rutas sidom */}
        <Route path="/about" element={<AboutUs />} />
        <Route path="/blogs" element={<Blog />} />
        <Route path="/notas/:slug" element={<BlogDetails />} />
        <Route path="/eventos/:slug" element={<EventDetail />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/pay" element={<Pay />} />
        <Route path="/sidom-insurance" element={<Isurance />} />
        <Route path="/sidom-misim" element={<Misim />} />
        <Route path="/sidom-smart-reader" element={<SmartReader />} />
        <Route path="/sidom-eventos" element={<Eventos />} />
        <Route path="/sidom-acceso-clientes" element={<AccesoAcliente />} />
        <Route path="/sidom-mre" element={<Mre />} />
        {/* Q&A Conocimiento PwC */}
        <Route path="/conocimientopwc" element={<FaqLanding />} />
        <Route path="/conocimientopwc/:id" element={<FaqDetail />} />

        <Route path="/politicas-de-privacidad" element={<PrivacyPolicy />} />
        <Route path="/login" element={<Login />} />

        {/* <Route
          path="/dashboard"
          element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          }
        /> */}
        <Route path="/info/:slug" element={<Landing />} />

        <Route path="*" element={<NotFound />} />
        {/** -----------------------------------------------*/}
      </Routes>
    </div>
  );
}

export default App;
